






































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Peripherals } from '@/shared/peripherals';
import VueStrong from '@/vueStrong';
import { ProjectMutations } from '@/store/types';

@Component({
  components: {
  },
})
export default class PeripheryList extends VueStrong {
  public Peripherals = Peripherals;

  selectPeriphery(periphery: string):void {
    this.$store.commit(ProjectMutations.SET_SELECTED_PERIPHERAL, periphery as Peripherals);
  }

  getIsActive(periphery: string):boolean {
    return this.$store.state.selectedPeripheral === (periphery as Peripherals);
  }
}
